module.exports = __webpack_public_path__ + "static/media/GoogleMeetEvent.fa015e61.svg";